// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Questioncard {
  width: 100%;
}

.assessment-que {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem; /* 24px / 16px */
}


@media (max-width: 600px) {
  .assessment-que {
    gap: 1rem; 
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Components/Questions-Card.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,gBAAgB;AAC/B;;;AAGA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".Questioncard {\n  width: 100%;\n}\n\n.assessment-que {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem; /* 24px / 16px */\n}\n\n\n@media (max-width: 600px) {\n  .assessment-que {\n    gap: 1rem; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
